<template>
    <div :class="containerClass">
        <!-- AMEX ICON -->
        <svg
          v-if="portal === 'amex'"
          width="20"
          height="20"
          viewBox="0 0 32 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect fill="#5FCCFF" height="20" width="32"/>
          <path
            fill="#FFFFFF"
            d="M7.673,9.347h1.378L8.36,7.667L7.673,9.347z M27.184,11.654l-0.279-0.303l-0.02-0.021l-0.02-0.021l-0.299-0.324l-0.273-0.297l-1.508-1.635l0.502-0.541V8.506l1.436-1.562h0.021l0.774-0.834h-3.58L23.111,7.01l-0.775-0.899h-7.912l-0.66,1.521l-0.671-1.521h-3.085v0.696L9.666,6.111h-2.63L6.981,6.237L6.976,6.23L6.534,7.26l-0.72,1.647v0.03L4.5,12.001l1.314-0.003h1.725l0.389-0.94h0.87l0.387,0.94h3.393v-0.718l0.304,0.721h1.759l0.302-0.729v0.727h2.105V12H17.5v-0.002h0.143v-0.001h4.586l0.859-0.915l0.809,0.915L26.99,12h0.51L27.184,11.654L27.184,11.654z M16.708,11.167h-1.033l-0.006-3.302l-1.462,3.302h-0.885l-1.47-3.309v3.309H9.801l-0.386-0.941H7.313l-0.39,0.941H5.827l1.804-4.221h1.501l1.715,3.998V6.947h1.649l1.318,2.865l1.214-2.865h1.68V11.167z M24.334,11.167l-1.242-1.396l-1.291,1.396h-3.996V6.945h4.059l1.24,1.383l1.283-1.383h1.326l-0.426,0.456L23.74,9.064l1.879,2.104H24.334z M18.809,7.82v0.766h2.215v0.861h-2.215v0.841h2.48l1.15-1.238L21.336,7.82H18.809z"
          />
        </svg>

        <svg
            v-else-if="portal === 'capitalone'"
            width="20"
            height="20"
            viewBox="0 0 1521 1350"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill="#cc2427"
                d="M169.24 18.25C369.48 5.08 570.32 -2.73 771.13 2.49C914.31 7.29 1057.96 16.6 1198.55 45.63C1277.81 63.17 1357.96 85.56 1427.29 129.17C1468.73 156.03 1509.37 193.61 1518.17 244.51C1529.08 303.54 1504.76 361.63 1474.99 411.35C1419.58 500.82 1344.04 575.51 1266.52 645.84C1168.78 732.62 1064.64 812.02 957.82 887.28C853.06 960.1 747.94 1032.44 641.16 1102.25C505.04 1189.69 365.81 1272.25 223.99 1350L31.42 1350C129.87 1281.65 222.39 1205.22 313.03 1126.9C424.74 1030.33 533.02 929.85 639.28 827.26C659.98 807.37 682.27 788.6 697.94 764.18C748.55 693.34 795.16 611.78 792.76 521.98C791.4 460.6 757.91 404.2 712.42 364.74C637.63 300.62 542.15 267.79 448.31 243.05C353.48 218.87 256.35 205.6 159.22 195.16C106.12 192.2 53.25 184.77 0 184.48L0 31.7C56.21 24.88 112.79 22.48 169.24 18.25Z"
            />
        </svg>

        <svg v-else-if="portal === 'chase'" width="20" height="20" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_907_19567)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.78573 0C6.4049 0 6.10156 0.317072 6.10156 0.709944V5.65553H18.7632L12.9957 0H6.78573Z"
                      fill="#005EB8" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M19.2253 7.15927C19.2253 6.7664 18.9219 6.45117 18.5394 6.45117H13.752V19.5241L19.2253 13.5719V7.15927Z"
                      fill="#005EB8" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12.2961 20.0033C12.672 20.0033 12.9836 19.6862 12.9836 19.2952V14.3496H0.320312L6.08448 20.0024L12.2961 20.0033Z"
                      fill="#005EB8" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M-0.148438 12.8451C-0.148438 13.2333 0.160728 13.5485 0.537394 13.5485H5.32906V0.474609L-0.14344 6.43057L-0.148438 12.8451Z"
                      fill="#005EB8" />
            </g>
            <defs>
                <clipPath id="clip0_907_19567">
                    <rect width="20.8333" height="20" fill="white" transform="translate(-0.914062)" />
                </clipPath>
            </defs>
        </svg>

        <svg v-else-if="portal === 'bofa'" width="20" height="20" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">

            <g transform="scale(0.15) translate(0, 0)">
                <path fill="#E31837" d="M77.6,69.1c0-1.6,1.3-2.9,3-2.9s3,1.3,3,2.9s-1.3,3-3,3S77.6,70.8,77.6,69.1 M78.2,69.1c0,1.3,1.1,2.4,2.5,2.4
		c1.3,0,2.4-1,2.4-2.4c0-1.3-1.1-2.3-2.4-2.3C79.2,66.8,78.2,67.9,78.2,69.1">
                </path>
                <path fill="#E31837" d="M82.1,70.8h-0.6l-1-1.5h-0.6v1.5h-0.4v-3.3H81c0.3,0,0.6,0,0.8,0.2c0.3,0.1,0.4,0.4,0.4,0.7
		c0,0.6-0.5,0.9-1.1,0.9L82.1,70.8L82.1,70.8z M80.5,68.9c0.5,0,1.1,0.1,1.1-0.5c0-0.4-0.4-0.5-0.8-0.5h-0.9v1H80.5L80.5,68.9z">
                </path>
                <path fill="#E31837" d="M66.3,72.1c21-18,50.5-35.5,66.7-41.8c-2.5-1.6-6.4-3.9-10.8-6.4c-20.9,6.9-45.3,22.2-67.1,39.5
		C58.8,66.2,62.7,69.1,66.3,72.1L66.3,72.1z">
                </path>
                <path fill="#012169" d="M56.7,23.2c-3.1-1.5-6.5-2.9-9.1-4.1c-7.9,3.9-18.2,9.8-31.2,19.1c2.8,1.5,5.8,3.3,9,5.1
		C35.4,35.9,45.5,28.9,56.7,23.2z">
                </path>
                <path fill="#E31837" d="M75.4,14.6c-3.8-2.1-17-7-26.1-9.1c-2.7,1-6.5,2.5-9.1,3.6c3.3,0.9,15.6,4.2,26.1,9.5
		C69,17.3,72.8,15.7,75.4,14.6z">
                </path>
                <path fill="#012169" d="M30.7,13.3C19,18.7,6.7,26.1,0,30.4c2.4,1.1,4.8,2,8.1,3.6c14.8-10,26.4-16.1,31-18.1
		C35.8,14.7,32.7,13.9,30.7,13.3L30.7,13.3z">
                </path>
                <path fill="#E31837" d="M84.2,11.5c2.7-0.9,5.8-1.7,8.5-2.5c-7.8-3.3-17.6-6.8-26.4-9c-1.4,0.4-5.6,1.5-8.5,2.4
		C60.8,3.3,70.7,5.6,84.2,11.5z M34.9,49.1c3.2,1.9,6.6,4.5,9.9,6.7c21.9-17,43.5-30.1,67.2-37.5c-3.3-1.7-6.2-3.2-9.9-5
		C87.9,16.9,63.6,26.6,34.9,49.1z">
                </path>
            </g>
        </svg>

        <svg v-else-if="portal === 'bilt'" version="1.0" xmlns="http://www.w3.org/2000/svg"
             width="20" height="20" viewBox="0 0 400.000000 400.000000"
             preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)"
               fill="#000000" stroke="none">
                <path d="M0 2000 l0 -2000 2000 0 2000 0 0 2000 0 2000 -2000 0 -2000 0 0
-2000z m2920 0 l0 -920 -920 0 -920 0 0 920 0 920 920 0 920 0 0 -920z" />
                <path d="M1220 2585 l0 -204 160 -3 160 -3 0 208 0 207 -160 0 -160 0 0 -205z" />
                <path d="M1680 2585 l0 -205 550 -2 550 -3 0 208 0 207 -550 0 -550 0 0 -205z" />
                <path d="M1220 2005 l0 -235 485 0 485 0 0 235 0 235 -485 0 -485 0 0 -235z" />
                <path d="M2330 2000 l0 -240 225 0 225 0 0 240 0 240 -225 0 -225 0 0 -240z" />
                <path d="M1220 1425 l0 -205 265 0 265 0 -2 203 -3 202 -262 3 -263 2 0 -205z" />
                <path d="M1880 1425 l0 -205 450 0 450 0 0 205 0 205 -450 0 -450 0 0 -205z" />
            </g>
        </svg>

        <svg v-else-if="portal === 'citi'" width="20" height="20" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">

            <clipPath id="a">
                <path clip-rule="evenodd" d="m0 0h560v400h-560z" />
            </clipPath>
            <path d="m0 0h560v400h-560z" fill="none" />
            <g transform="scale(0.06) translate(-100, -40)" clip-path="url(#a)">
                <path
                    d="m273.841 164.756h-24.66v119.762h24.66zm22.307 0v22.316h21.131v67.509c0 9.402 1.765 17.031 7.049 22.904 5.285 5.277 11.746 8.217 19.963 8.797 8.806 0 15.847-1.764 21.712-5.865l5.872-21.131v-1.764l-1.168.58c-6.453 4.117-12.326 6.461-18.198 6.461-7.63 0-11.15-4.705-11.15-13.51v-63.989h24.652v-22.308h-24.652v-36.993l-24.08 12.334v24.659zm118.594 0h-24.66v119.762h24.66zm-221.929-1.764c-17.61 0-32.288 4.705-44.034 15.846-12.906 11.158-18.779 26.424-18.779 45.799 0 18.787 5.873 34.641 18.779 45.799 11.746 11.149 26.424 16.434 44.034 16.434 16.443 0 30.541-7.049 42.27-20.543v-.588l-13.502-16.434-.58.588c-8.805 8.797-18.198 13.494-29.348 13.494-10.578 0-19.383-3.521-26.424-11.15-7.049-7.049-10.569-15.854-10.569-27.6 0-11.15 3.52-20.551 10.569-27.592 7.041-7.637 15.846-10.57 26.424-10.57 11.15 0 20.543 4.109 29.348 12.914l.58.588 13.502-16.434v-.588c-11.729-13.502-25.827-19.963-42.27-19.963z"
                    fill="#1c4882" />
                <path
                    d="m261.515 145.374c19.375-20.544 42.859-30.525 70.451-30.525 26.996 0 50.495 9.981 69.274 30.525h28.76l-.58-1.765c-11.15-15.846-25.836-27.592-43.446-36.977-17.031-9.394-35.23-13.502-54.008-13.502-19.375 0-37.582 4.108-54.604 13.502-17.619 9.393-31.709 21.131-42.867 36.977l-1.168 1.765z"
                    fill="#cf4037" />
            </g>

        </svg>

        <svg v-else-if="portal === 'wellsfargo'" xmlns="http://www.w3.org/2000/svg" height="20" width="20"
             viewBox="-3.63972 -6.0662 31.54424 36.3972">
            <path d="M0 24.2648h24.2648V0H0z" fill="#dd1e25" />
            <path
                d="M20.9117 14.9291c0-.975-.4022-1.5423-1.1458-1.5423-.7437 0-1.1459.5673-1.1459 1.5423 0 .9808.3966 1.5427 1.1459 1.5427.749 0 1.1458-.562 1.1458-1.5427m.9035 0c0 1.2009-.8538 2.044-2.0493 2.044-1.19 0-2.0493-.8431-2.0493-2.044 0-1.1952.8646-2.0436 2.0493-2.0436 1.1895 0 2.0493.8484 2.0493 2.0436m-6.1924.1764c0 .11.0166.1817.0607.2699h.6555v.975a1.6844 1.6844 0 01-.6498.1267c-.793 0-1.2065-.5672-1.2065-1.548 0-.9807.4134-1.548 1.1624-1.548.5013 0 .7934.248.9638.6777l.0606.1542h.397v-.986c-.4961-.2367-.9424-.3415-1.4599-.3415-1.2121 0-2.0274.8096-2.0274 2.0493 0 1.245.7934 2.0383 2.0274 2.0383.49 0 .997-.138 1.5424-.4078v-1.7187h-1.4655c-.044.0882-.0607.1541-.0607.259m-3.3492-1.0027c0-.4021-.248-.617-.744-.617h-.6499v1.2393h.6499c.4903 0 .744-.2257.744-.6223m-4.3138 1.1236l-.5397-1.4594-.5401 1.4594zm5.382 1.2009c.0335.0607.05.1323.05.2261 0 .0935-.0165.1651-.05.2258a3.298 3.298 0 01-.4293.0275c-.5345 0-.7934-.2205-.8538-.7327l-.0222-.1926c-.066-.5564-.2476-.7712-.8537-.7712h-.303v1.173h.5231v.4794H7.9376v-.4794h.4519l-.2533-.6883H6.7039l-.2533.6883h.4625v.4794H5.4533v-.4794h.3856l1.3497-3.3768h.7328l1.3772 3.3768h.7602v-2.8974h-.4681v-.4794h2.2147c.7874 0 1.2997.3912 1.2997 1.0192 0 .6226-.5123.9528-1.008.975v.0166c.5014.0388.7053.3196.7547.7546l.0222.204c.0328.3195.0991.4628.3524.4628a.6648.6648 0 00.1154-.0113m-8.3954-2.9415c.369 0 .4956.1598.617.6227l.0384.1485h.3966v-1.2506H2.6766v.4794h.4685v2.8974h-.4685v.4794h1.84v-.4794h-.551v-1.1236h1.135c.044.0935.0603.1599.0603.2643 0 .11-.0162.1817-.0603.2755H9.1388v1.1956h.9532c.3577 0 .5175-.1546.6276-.6446l.0444-.193h.3966v1.3166H7.8497v-.479h.4685V7.6407h-.761l-.9637 3.3768h-.7659l-.782-2.7982-.8044 2.7982z"
                fill="#fff" />
        </svg>


        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_907_19575)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.38426 9.16602H5.85208C5.93804 7.32932 6.306 5.65094 6.88082 4.3576C6.93104 4.24461 6.98321 4.1337 7.03736 4.02518C5.07839 4.9983 3.66601 6.9066 3.38426 9.16602ZM9.99935 1.66602C5.39698 1.66602 1.66602 5.39698 1.66602 9.99935C1.66602 14.6017 5.39698 18.3327 9.99935 18.3327C14.6017 18.3327 18.3327 14.6017 18.3327 9.99935C18.3327 5.39698 14.6017 1.66602 9.99935 1.66602ZM9.99935 3.33268C9.81026 3.33268 9.56739 3.41543 9.27635 3.6924C8.98103 3.97345 8.67716 4.41953 8.40384 5.0345C7.93595 6.08723 7.60548 7.52724 7.52074 9.16602H12.478C12.3932 7.52724 12.0627 6.08723 11.5949 5.0345C11.3215 4.41953 11.0177 3.97345 10.7223 3.6924C10.4313 3.41543 10.1884 3.33268 9.99935 3.33268ZM14.1466 9.16602C14.0607 7.32932 13.6927 5.65094 13.1179 4.3576C13.0677 4.24461 13.0155 4.1337 12.9613 4.02518C14.9203 4.9983 16.3327 6.9066 16.6144 9.16602H14.1466ZM12.478 10.8327H7.52074C7.60548 12.4715 7.93595 13.9115 8.40384 14.9642C8.67715 15.5792 8.98103 16.0252 9.27635 16.3063C9.56739 16.5833 9.81026 16.666 9.99935 16.666C10.1884 16.666 10.4313 16.5833 10.7223 16.3063C11.0177 16.0252 11.3215 15.5792 11.5949 14.9642C12.0627 13.9115 12.3932 12.4715 12.478 10.8327ZM12.9613 15.9735C13.0155 15.865 13.0677 15.7541 13.1179 15.6411C13.6927 14.3478 14.0607 12.6694 14.1466 10.8327H16.6144C16.3327 13.0921 14.9203 15.0004 12.9613 15.9735ZM7.03736 15.9735C6.98321 15.865 6.93104 15.7541 6.88082 15.6411C6.306 14.3478 5.93804 12.6694 5.85208 10.8327H3.38426C3.66601 13.0921 5.07839 15.0004 7.03736 15.9735Z"
                      fill="#1E293B" />
            </g>
            <defs>
                <clipPath id="clip0_907_19575">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>


    </div>
</template>

<style>
tspan {
    white-space: pre
}

.shp0 {
    fill: #cc2427
}
</style>


<script setup>
import { computed } from 'vue';

const props = defineProps({
    portal: {
        type: String,
        default: 'other',
    },
    width: {
        type: [String, Number],
        default: 20,
    },
    height: {
        type: [String, Number],
        default: 20,
    },
    containerClass: {
        type: [String, Object, Array],
        default: '',
    },
    svgClass: {
        type: [String, Object, Array],
        default: '',
    },
});
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>
